import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";
import { range, isEmpty } from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef } from "ng-zorro-antd/modal";
import { delay } from "rxjs";
import { EditMode, RobotRulesService } from "../robot-rules.service";
import { padStart } from "@root/util/date";
import { DateService } from "@root/shared/service/date.service";

@Component({
  selector: "host-price-rules",
  templateUrl: "./price-rules.component.html",
  styleUrls: ["./price-rules.component.scss"],
})
export class PriceRulesComponent implements OnInit {
  @Input() id;
  @Input() editMode: EditMode = EditMode.Create;
  @Input() listOfChannelOption = [];
  listOfAccountOption = [];
  readonly listOfTimeOption = range(0, 25)
    .map((hour) => {
      return [0, 30].map((min) => ({
        label: `${padStart(hour)}:${min === 0 ? "00" : "30"}`,
        value: hour * 60 + min,
      }));
    })
    .flat();
  private readonly defaultScopeChannels = [-1];
  private readonly defaultScopeAccounts = [-1];
  private readonly defaultScopeHouses = [-1];

  // readonly listOfTimeOption = range(0, 25).map(hour => ({ label: `${padStart(hour, 2, '0')}:00`, value: hour * 60 }));
  scopeHouses = {
    type: "none",
    value: this.defaultScopeHouses,
  };
  scopeForm: UntypedFormGroup = this.fb.group({
    thirdparty: null,
    account: null,
    // house_type: "none",
    // house_type_ids: null,
  });
  actionForm: UntypedFormGroup = this.fb.group({
    node_minute: 13 * 60, // 默认13点
    to_percent: 90,
  });

  get houseType() {
    return this.scopeForm.get("house_type").value;
  }

  get percent() {
    return this.actionForm.get("to_percent").value;
  }

  padStart = padStart;

  constructor(
    private fb: UntypedFormBuilder,
    private t: TranslateService,
    private ruleSrv: RobotRulesService,
    private msg: NzMessageService,
    private modalRef: NzModalRef,
    private date: DateService,
  ) {}

  ngOnInit() {
    if (this.editMode === EditMode.Update || this.editMode === EditMode.Copy) {
      this.fetchRuleDetail();
    } else {
      this.fetchAccounts();
    }

    this.subscribeFormChange();
  }

  private subscribeFormChange() {
    // this.scopeForm.get("house_type").valueChanges.subscribe((rst) => {
    //   this.scopeForm.patchValue({ house_type_ids: null });
    // });
    this.scopeForm
      .get("thirdparty")
      .valueChanges.pipe(delay(10))
      .subscribe((c) => {
        console.log("thirdparty changes: ", c);
        this.fetchAccounts();
      });
  }

  private fetchRuleDetail() {
    this.ruleSrv.fetchPriceRuleDetail({ id: this.id }).subscribe((rst) => {
      if (rst.error_code === 0) {
        const { action, scope } = rst?.data?.record;
        this.convertFromActionParams(action);
        this.convertFromScopeParams(scope);

        this.fetchAccounts();
      }
    });
  }
  private fetchAccounts() {
    const channels = this.scopeForm.value.thirdparty;
    console.log("channels: ", channels);

    const params = {
      from: "price",
    };
    if (channels) {
      Object.assign(params, { thirdparty_types: JSON.stringify(channels) });
    }
    this.ruleSrv.fetchChannelAccounts(params).subscribe((rst) => {
      this.listOfAccountOption = (rst?.data?.list ?? []).map((a) => ({
        label: a.username,
        value: a.id,
      }));
    });
  }

  private convertToActionParams() {
    console.log("conver to action params: ", this.actionForm.value);
    const form = this.actionForm.value;
    const result = {
      node_minute: form.node_minute,
      to_percent: (form.to_percent / 100)?.toFixed(2),
    };
    return result;
  }

  private convertToScopeParams() {
    const form = this.scopeForm.value;
    const result = {
      thirdparty: this.getOrDefault(form.thirdparty, this.defaultScopeChannels),
      account: this.getOrDefault(form.account, this.defaultScopeAccounts),
    };

    const { type, value } = this.scopeHouses;
    const scopeHouses = this.getOrDefault(value, this.defaultScopeHouses);

    if (type === "none") {
      Object.assign(result, { property_any: [-1] });
    } else if (type === "house") {
      Object.assign(result, { house: scopeHouses });
    } else if (type === "group") {
      Object.assign(result, { group: scopeHouses });
    } else {
      Object.assign(result, { room_type: scopeHouses });
    }

    // if (this.houseType === "none" || this.houseType === "house") {
    //   const ids = this.getOrDefault(
    //     form.house_type_ids?.map((h) => ({ id: h })),
    //     this.defaultScopeHouses
    //   );
    //   Object.assign(result, {
    //     house: ids,
    //   });
    // } else {
    //   if (form.house_type_ids) {
    //     const [type, _ids] = form.house_type_ids;
    //     const ids = _ids.map((i) => ({ id: i }));
    //     if (type === "group") {
    //       Object.assign(result, { house_group: ids });
    //     } else {
    //       Object.assign(result, { room_type: ids });
    //     }
    //   }
    // }
    return result;
    console.log("conver to scope params: ", this.scopeForm.value);
  }

  private convertFromActionParams(params) {
    this.actionForm.patchValue({
      node_minute: params.node_minute,
      to_percent: params.to_percent * 100,
    });
  }

  private convertFromScopeParams(params) {
    let scopeAccounts, scopeChannels;
    if (params.account?.[0] === -1) {
      scopeAccounts = null;
    } else {
      scopeAccounts = params.account;
    }

    if (params.thirdparty?.[0] === -1) {
      scopeChannels = null;
    } else {
      scopeChannels = params.thirdparty;
    }

    this.scopeForm.patchValue({
      thirdparty: scopeChannels,
      account: scopeAccounts,
    });

    if (params.group) {
      this.scopeHouses = {
        type: "group",
        value: params.group,
      };
    } else if (params.room_type) {
      this.scopeHouses = {
        type: "room_type",
        value: params.room_type,
      };
    } else {
      if (params.house?.[0] === -1 || params.property_any?.[0] === -1) {
        this.scopeHouses = {
          type: "none",
          value: [-1],
        };
      } else {
        this.scopeHouses = {
          type: "house",
          value: params.house,
        };
      }
    }
  }

  private getOrDefault(value: any[], defaults) {
    if (isEmpty(value)) {
      return defaults;
    }
    return value;
  }

  private requestSaveRules() {
    const action = this.convertToActionParams();
    const scope = this.convertToScopeParams();
    console.log("scope: ", scope, " action: ", action);
    const params = { action, scope };

    if (this.editMode === EditMode.Update) {
      Object.assign(params, { id: this.id });
    }

    this.ruleSrv.updatePriceRobotRules(params).subscribe((rst) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.syncGet("word.success"));

        this.close();
      }
    });
  }

  onCancel() {
    this.close();
  }

  onSave() {
    this.requestSaveRules();
  }

  close() {
    this.modalRef.destroy();
  }

  normalizeTimeString(time: string) {
    if (!this.date.use12hr) {
      return time;
    }

    const [min, sec] = time.split(":");
    const prefix = "2022-11-11T";
    if (+min >= 24) {
      return this.t.t("word.next_day") + " " + this.date.format(`${prefix}${padStart(+min % 24)}:${sec}`, [null, "hm"]);
    } else {
      return this.date.format(`${prefix}${time}`, [null, "hm"]);
    }
  }
}
